<ng-container *ngIf="viewModel$ | async as vm">
  <ng-container *ngIf="showChatUserList === false">
    <ul class="nav nav-tabs menu">
      <li class="nav-item" *ngIf="showAllChat">
        <a
          class="nav-link"
          [ngClass]="{ active: vm.activeRoom === 'All Chat' }"
          (click)="selectRoom('All Chat')"
        >
          All Chat
        </a>
      </li>
      <li
        class="nav-item"
        *ngFor="
          let room of showSettings ? (vm.favourites | slice: 0:30) : vm.rooms
        "
      >
        <a
          class="nav-link"
          [ngClass]="{
            active: vm.activeRoom === room.group,
            'nav-link-mini': !showAllChat
          }"
          (click)="selectRoom(room.group)"
          >{{ room.private ? room.groupName : room.group }}
          <i
            *ngIf="room.private && room.groupName !== 'Personal'"
            class="fa fa-window-close"
            aria-hidden="true"
            (click)="closePersonalChat(room.group)"
          ></i>
        </a>
      </li>
      <li class="nav-item ml-auto" *ngIf="showSettings">
        <a
          class="nav-link"
          (click)="openSettings()"
          title="Manage Favourites and All Chat"
        >
          <i class="fa fa-cog" aria-hidden="true"></i>
        </a>
      </li>
    </ul>
    <ng-container *ngIf="!!vm.activeRoom; else noRoomSelected">
      <lib-chat-pinned-message
        [currentUserId]="vm.currentUserId"
        [messages]="vm.pinned | filterBy: msgPinnedPredicate(vm.activeRoom)"
        [showGroup]="vm.activeRoom === 'All Chat'"
        [showSettings]="showSettings"
        *ngIf="vm.pinned?.length || 0 > 0"
      ></lib-chat-pinned-message>

      <lib-chat-messages
        [currentUserId]="vm.currentUserId"
        [messages]="vm.messages | filterBy: msgPredicate(vm.activeRoom)"
        [showGroup]="vm.activeRoom === 'All Chat'"
        [showSettings]="showSettings"
      ></lib-chat-messages>
    </ng-container>
    <form [formGroup]="chatForm">
      <div class="input-group" [ngClass]="{ 'input-group-sm': !showAllChat }">
        <div class="input-group-prepend">
          <ng-select
            *ngIf="showAllChat && vm.activeRoom === 'All Chat'"
            [items]="vm.allchat || null"
            bindLabel="group"
            bindValue="group"
            formControlName="room"
            [selectOnTab]="true"
            [closeOnSelect]="true"
            style="width: 8rem"
          >
          </ng-select>
        </div>
        <input
          #msg
          type="text"
          class="form-control"
          formControlName="msg"
          (keyup.enter)="sendMsg(vm.activeRoom, showSettings)"
          autocomplete="off"
          [readOnly]="!showSettings && vm.readOnly"
          [value]="vm.readOnly ? 'Read Only' : ''"
        />
        <div class="input-group-append">
          <!--<button
            class="btn btn-primary"
            type="button"
            (click)="sendMsg(vm.activeRoom, showSettings)"
            [disabled]="!showSettings && vm.readOnly"
          >
            &gt;
          </button> -->
          <button
            class="btn btn-secondary-outline"
            type="button"
            (click)="toggleEmojis()"
            [disabled]="!showSettings && vm.readOnly"
          >
            <i class="fas fa-smile"></i>
          </button>
          <button
            class="btn btn-secondary-outline"
            type="button"
            (click)="showUserList()"
          >
            <i class="fa fa-users"></i>
          </button>
        </div>
      </div>
      <div *ngIf="vm.showEmojis" class="text-right">
        <ng-container *ngFor="let emoji of vm.emojis" class="col-auto">
          <span
            class="cursor-pointer"
            innerHtml="{{ emoji.unicode }}"
            (click)="addEmojiToMsgbox(emoji.unicode)"
          ></span>
        </ng-container>
      </div>
    </form>
  </ng-container>
  <ng-template #noRoomSelected>
    <div
      class="
        d-flex
        flex-column
        d-flex
        justify-content-center
        align-items-center
        flex-grow-1
        bg-light
        body-border
      "
    >
      <span>No Chat Room Selected...</span>
    </div>
  </ng-template>
</ng-container>
<div
  *ngIf="showChatUserList"
  class="d-flex flex-column flex-grow-1 bg-light body-border"
>
  <lib-chat-user-list></lib-chat-user-list>
</div>
